import { Component, OnInit, ElementRef } from '@angular/core';
import { MapsSidebarService } from '../../maps-sidebar.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-measure-filter',
  templateUrl: './measure-filter.component.html',
  styleUrls: ['./measure-filter.component.less']
})
export class MeasureFilterComponent implements OnInit {

  distanceState: boolean = true;
  isMeasureOn: boolean = true;
  measureFilterActiveSubscription: Subscription;
  closeOnClickRef: any;

  distanceAddedSubscription: any;
  measureFiltersChangedSubscription: any;

  constructor(public mapsSidebarService: MapsSidebarService, public elementRef: ElementRef) { }

  ngOnInit() {
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.measureFilterActiveSubscription = this.mapsSidebarService.measaureFilterActiveStream.subscribe((value)=> {
      if(value) {
        document.addEventListener('click', this.closeOnClickRef, true);
      }
   });
  }

  ngAfterViewInit() {
    let w = (<any>window);
    this.distanceAddedSubscription = w.Events.subscribe('distanceAdded',()=>{
      this.distanceState = true;
      this.toggleMeasure(true);
    });

    this.measureFiltersChangedSubscription = w.Events.subscribe('measureFiltersChanged',()=>{
      this.distanceState = w.mapData.showDistances;
      this.toggleMeasure(w.mapData.measureFilterActive);
    });
  }

  closeOnOutsideClick(event: Event) {
    let w = (<any>window);
    if (event.target !== this.elementRef.nativeElement
        && !this.elementRef.nativeElement.contains(event.target)
        && !w.hasClass(event.target, 'layer-filter-sub-header')
        && !w.hasClass(event.target, 'toggle-layers-holder')
        && !w.hasClass(event.target, 'filter-counter')
        && !w.hasClass(event.target, 'measure-icon')
        && !w.hasClass(event.target, 'a')
        && !w.hasClass(event.target, 'b')
        && !w.hasClass(event.target, 'c')
        && !w.hasClass(event.target, 'd')
        && !w.hasClass(event.target, 'arrow-icon')) {
        this.closeMeasureFilter();
        document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  closeMeasureFilter() {
    this.mapsSidebarService.showMeasureFilter = false;
    (<any>window).Events.publish('detectChanges');
    (<any>window).localStorageHandler.updateSideBarToLS();
  }

  toggleMeasure(event) {
    let w = (<any>window);
    let toggle = (event.target !== undefined)? event.target.checked : event;
    this.isMeasureOn = toggle;
    w.setMapDataProperty('measureFilterActive', toggle);
    w.distance.toggleVisible((toggle)? this.distanceState: false);
    w.Events.publish('detectChanges');
    w.localStorageHandler.updateDistanceData();
  }

  addDistance() {
    let w = (<any>window);
    w.addClass((<any>window).domBody, 'add-stuff');
    w.distance.add();
    this.distanceState = true;
    w.setMapDataProperty('showDistances', true);
    this.isMeasureOn = true;
    w.setMapDataProperty('measureFilterActive', true);
  }

  getDistanceCount() {
    return ((<any>window).distance.polylines)? ((<any>window).distance.polylines.length): 0;
  }

  isDistanceChecked() {
    return this.distanceState;
  }

  toggleDistances(event) {
    let w = (<any>window);
    this.distanceState = event.target.checked;
    w.setMapDataProperty('showDistances', event.target.checked);
    w.distance.toggleVisible(event.target.checked);
    w.localStorageHandler.updateDistanceData();
  }

  resetMeasure() {
    (<any>window).distance.deleteAll();
  }

  resetSubscriptions() {
    this.measureFilterActiveSubscription && this.measureFilterActiveSubscription.unsubscribe();
    this.distanceAddedSubscription && this.distanceAddedSubscription.unsubscribe();
    this.measureFiltersChangedSubscription && this.measureFiltersChangedSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.resetSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/measure-filter/measure-filter.component.ts